import cc from 'classcat'

import { useTranslate } from '../../../../../utils/translate'
import CheckboxField from '../../../../formComponents/CheckboxField'
import FormGroup from '../../../../formComponents/FormGroup'
import FormValue from '../../../../formComponents/FormValue'
import InputField from '../../../../formComponents/InputField'
import LinkTooltipSettingsLayer from './LinkTooltip/LinkTooltipSettingsLayer'

type ImageTextSettingsProps = {
  imageInfo: {
    isSlider: boolean
    src: string
  }
}

export default function ImageTextSettings({ imageInfo }: Readonly<ImageTextSettingsProps>) {
  const isSlider = Boolean(imageInfo?.isSlider)
  const componentName = isSlider ? 'contentSliderComponent' : 'imageElementComponent'
  const isDisabled = !imageInfo?.src

  const t = useTranslate('interface', `components.${componentName}.settingsModal`)

  return (
    <>
      <FormGroup
        className={cc([{ disabled: isDisabled }])}
        name="headline"
        tagName="label"
        label={t('headlineInputField.label')}
      >
        <InputField autoFocus name="headline" type="text" disabled={isDisabled} />
      </FormGroup>
      <FormGroup
        className={cc([{ disabled: isDisabled }])}
        name="text"
        tagName="label"
        label={t('textInputField.label')}
      >
        <InputField name="text" type="text" disabled={isDisabled} />
      </FormGroup>
      <FormValue name="link">
        {(link, setLink) => {
          const linkFieldIsActive = Boolean(link)

          return (
            <>
              <LinkTooltipSettingsLayer
                t={t}
                link={link}
                setLink={setLink}
                label={'linkInputField.label'}
                disabled={isDisabled}
              />
              <FormGroup
                className={cc(['ep-form-row-min-margin', { disabled: !linkFieldIsActive || isDisabled }])}
                name="opentab"
                tagName="label"
                label={t('openLinkInNewTabCheckbox.label')}
                labelAfterComponent
              >
                <CheckboxField name="opentab" disabled={!linkFieldIsActive || isDisabled} />
              </FormGroup>
              <FormValue name="buttonenabled">
                {(isEnabled) => (
                  <>
                    <FormGroup
                      className={cc([{ disabled: !linkFieldIsActive || isDisabled }])}
                      name="buttonenabled"
                      tagName="label"
                      label={t('buttonenabledInputFieldCheckbox.label')}
                      labelAfterComponent
                    >
                      <CheckboxField name="buttonenabled" disabled={!linkFieldIsActive || isDisabled} />
                    </FormGroup>
                    <FormGroup
                      className={cc({ disabled: !isEnabled })}
                      name="buttontext"
                      tagName="label"
                      label={t('buttonTextInputField.label')}
                    >
                      <InputField name="buttontext" type="text" disabled={!isEnabled} />
                    </FormGroup>
                  </>
                )}
              </FormValue>
            </>
          )
        }}
      </FormValue>
    </>
  )
}
